import { Image } from "common/types/images";

import { getCdnImageDetails } from "seneca-common/utils/images";

import {
  ImageAssetParameters,
  MultipleChoiceContent,
  MultipleChoiceContentSource
} from "../types";

export function getModuleAssets(source: MultipleChoiceContent): Array<Image> {
  return source.image ? [source.image] : [];
}

export function transformModuleAssets(
  source: MultipleChoiceContentSource,
  assetParams: ImageAssetParameters
): MultipleChoiceContent {
  if (source.imageURL) {
    return {
      ...source,
      image: getCdnImageDetails(source.imageURL, assetParams.default)
    } as unknown as MultipleChoiceContent;
  }

  return source as unknown as MultipleChoiceContent;
}
